export default 'hasImportedLegacyData';
